import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';

export const GIFT_CARDS_TAGS = Object.freeze({
  GIFT_CARDS: 'gift_cards',
});

// Invalidate the gift-cards cache after a successful mutation; on error invalidate
// nothing so a failed write doesn't trigger a needless refetch. Exported for testing.
export const invalidateGiftCardsUnlessError = (_result, error) => (error ? [] : [GIFT_CARDS_TAGS.GIFT_CARDS]);

export const giftCardsApiSlice = createApi({
  reducerPath: 'giftCardsApiSlice',
  baseQuery,
  tagTypes: Object.values(GIFT_CARDS_TAGS),
  endpoints: (builder) => ({
    getGiftCards: builder.query({
      query: ({ apiManager, franchiseId, ...params }) => apiManager.get(params),
      providesTags: [GIFT_CARDS_TAGS.GIFT_CARDS],
    }),
    createGiftCard: builder.mutation({
      query: ({ apiManager, ...rest }) => apiManager.create(rest),
      invalidatesTags: invalidateGiftCardsUnlessError,
    }),
    redeemGiftCard: builder.mutation({
      query: ({ apiManager, ...rest }) => apiManager.redeem(rest),
      invalidatesTags: invalidateGiftCardsUnlessError,
    }),
    checkGiftCardBalance: builder.mutation({
      query: ({ apiManager, ...rest }) => apiManager.checkBalance(rest),
    }),
  }),
});

export const {
  useGetGiftCardsQuery,
  useCreateGiftCardMutation,
  useRedeemGiftCardMutation,
  useCheckGiftCardBalanceMutation,
} = giftCardsApiSlice;
